import { createAsyncThunk } from '@reduxjs/toolkit'

import { API } from '@/api'
import { GetUserShortcutsResponse, UserShortcut } from '@/api/LabelingNode/types'

import { ThunkConfig } from '@/stores/slices/Labeling/types'

export const saveUserShortcuts = createAsyncThunk<GetUserShortcutsResponse, UserShortcut[], ThunkConfig>(
  'labeling/save-user-shortcuts',
  async (shortcuts) => {
    const savedShortcuts = await API().Labeling.updateUserShortcuts({ shortcutKeySettings: shortcuts })
    return savedShortcuts
  }
)

export const updateUserRole = createAsyncThunk<any, 'LABELER' | 'REVIEWER', ThunkConfig>(
  'labeling/update-user-role',
  async (role, thunkAPI) => {
    const { labelingNodeId } = thunkAPI.getState().labeling
    const { user } = thunkAPI.getState().user

    const { labelingMembers, reviewers } = await API().Labeling.updateAssignRole(labelingNodeId, { role })

    return { labelingMembers, reviewers, userId: user._id }
  }
)
